import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	NgModule,
	Output,
} from '@angular/core';

import { UiNewButtons } from '~app-ui-new/buttons';

@Component({
	standalone: false,

	selector: 'onboarding-spotlight-message',
	templateUrl: './spotlight-message.component.html',
	styleUrls: ['./spotlight-message.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		tabindex: '-1',
	},
})
export class OnboardingSpotlightMessageComponent {
	@Input()
	public showFooter = false;

	@Input()
	public showGotIt = false;

	@Output('footerClicked')
	public readonly footerClicked$ = new EventEmitter<void>();

	@Output('markAsSeen')
	public markAsSeen$ = new EventEmitter<void>();

	public markAsSeen(): void {
		this.markAsSeen$.emit();
	}
}

@NgModule({
	declarations: [OnboardingSpotlightMessageComponent],
	imports: [CommonModule, UiNewButtons],
	exports: [OnboardingSpotlightMessageComponent],
})
export class OnboardingSpotlightMessageComponentModule {}
